import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {MatPaginator} from '@angular/material';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {

  summary: any;
  dataLoading = true;
  dataErrorMessage: string;

  items: any;
  languages: any;
  languageSelected = 'en';
  @Input() language: string;
  columns: string[] = [];
  columns1: string[] = [];
  navigate: any;
  searchText: any;
  itemLength: any;
  filterData: any[];
  settings = {text: 'Select attribute(s) to search instantly'};
  @Input() partner: string;
  @Input() account: string;
  @Input() entity: string;
  @Input() version: string;
  partnerKey: string;
  itemList: any[];
  options: any;
  userView = 'table';
  error = false;
  dataSource: any;
  dataModel: any;
  primaryKey = null;
  errorMessage: string;
  options1 = new JsonEditorOptions();
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectedAttributeQuery: any;
  selectedOperatorQuery: any;
  querySearchText:any;
  apiByDefinition: any;
  query:any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  queries=[];
  queryColumns=[];
  querrParam='';
  columnSelection = new FormControl();
  totalPages: any;
  currentPage: any;
  currentOffset = 980;
  limit = 20;
  table: any;
  collectionSize: any;
  page = 1;
  currentPageDisplayed = 1;
  itemsPerPage = 20;
  selectedItemsPerPageIndex = 2;

  constructor(public confPost: ConfService) { }

  ngOnInit() {
    this.confPost.getPartnerAPISummary().subscribe(response => {
      this.dataLoading = false;
      this.summary = response;
      this.error = false;
        // this.apiByDefinition = response;
        // let idFound = false;
              this.items = response;
              const tempItems = [];
              const tempArray = [];

              const keys = Object.keys(this.summary[0]);

              for (const definition of keys) {
                if (definition && definition !== null && definition !== undefined) {
                  for (const item of Object.keys(this.items[0])) {
                    if (item && item !== null && item !== undefined) {
                      if (definition.toLowerCase() === item.toLowerCase()) {
                        tempArray.push(item);
                      }
                      // if (definition['attributeName'].toLowerCase() === 'id') {
                      //   idFound = true;
                      // }
                    }
                  }
                }
              }
              // if (idFound === false) {
              //   tempArray.push('id');
              // }
              for (const item of this.items) {
                const tempObject = {};
                for (const field of tempArray) {
                  if (field && field !== null && field !== undefined) {
                    for (const itemField of Object.keys(item)) {
                      if (itemField.toLowerCase() === field.toLowerCase()) {
                        tempObject[itemField] = item[itemField];
                      }
                    }
                  }
                }
                tempItems.push(tempObject);
              }
              this.items = tempItems;
              if (this.items && this.items !== null && this.items !== undefined) {
                for (const item of this.items) {
                  this.columns = [];
                  this.columns1 = [];
                  for (const itemval in item) {
                    this.columns.push(itemval);
                    this.columns1.push(itemval);
                  }
                }
              }
                for (let i = 0; i < keys.length; i++) {
                  for (let j = 0; j < this.columns.length; j++) {
                    if (keys[i] === this.columns[j]) {
                      // if (this.apiByDefinition['attributes'][i]['displayName'] !== null && this.apiByDefinition['attributes'][i]['displayName'] !== '') {
                        this.columns1[j] = keys[i];
                      // }
                    }
                  }
                }
              this.itemList = [];
              for (let t = 0; t < this.columns.length; t++) {
                const tempObj = {};
                tempObj['id'] = t;
                tempObj['itemName'] = this.columns[t];
                this.itemList.push(tempObj);
              }
              // for (let t = 0; t < this.columns.length; t++) {
              //     const tempObj = {};
              //     tempObj['id'] = t;
              //     if (this.columns[t] !== this.columns1[t]) {
              //         tempObj['itemName'] = this.columns[t] + ' (' + this.columns1[t] + ')';
              //     } else {
              //         tempObj['itemName'] = this.columns[t];
              //     }
              //     this.itemList.push(tempObj);
              // }
              this.options = {
                fieldSeparator: ',',
                quoteStrings: '',
                decimalseparator: '.',
                headers: this.columns,
                showTitle: false,
                useBom: true,
                noDownload: false,
                nullToEmptyString: true,
                removeNewLines: false,
                keys: []
              };
    });
  }

  timeConverter(ts) {
    if (ts !== 0) {
      let str = '';
      const date_ob = new Date(ts);
      const year = date_ob.getFullYear();
      const month = ('0' + (date_ob.getMonth() + 1)).slice(-2);
      const date = ('0' + date_ob.getDate()).slice(-2);
      const hours = ('0' + date_ob.getHours()).slice(-2);
      const minutes = ('0' + date_ob.getMinutes()).slice(-2);
      const seconds = ('0' + date_ob.getSeconds()).slice(-2);
      str = str + date + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
      return str;
    } else {
      return '-';
    }
  }

  checkFilter() {
    if (!this.filterData || this.filterData === [] || this.filterData === null) {
      alert('Please select an attribute to filter.');
      this.searchText = '';
    }
  }

  typeOfval(val) {
    return typeof val;
  }

  stringifyjson(val) {
    return JSON.stringify(val, null, 2).trim();
  }

}
